import { PptSlide } from '../types/ppt-slide';
import { PPT_MAKER_THEMES, ThemeType } from '@lessonPlanner/constants';
import { getLayoutBackgroundImage, clearLayoutImageCache } from '../hooks/useLayoutBackground';

const slideBackgroundCache: Record<string, string> = {};

export function clearLayoutBackgroundCache(): void {
  Object.keys(slideBackgroundCache).forEach(key => {
    delete slideBackgroundCache[key];
  });
}

export function clearAllLayoutCaches(): void {
  clearLayoutBackgroundCache();
  clearLayoutImageCache();
}

export function getLayoutBackgroundUrl(
  themeId: string, 
  slideIndex: number, 
  slides: PptSlide[]
): string {
  const cacheKey = `${themeId}-${slideIndex}`;
  
  if (slideBackgroundCache[cacheKey]) {
    return slideBackgroundCache[cacheKey];
  }

  const theme = PPT_MAKER_THEMES[themeId as ThemeType];
  const slide = slides[slideIndex];
  
  let backgroundImage = '';
  
  if (theme.layoutImages && slide?.layout) {
    const layoutImage = getLayoutBackgroundImage(theme, slide.layout);
    if (layoutImage) {
      backgroundImage = layoutImage;
    }
  }
  
  if (!backgroundImage && theme.backgroundImageContent) {
    if (typeof theme.backgroundImageContent === 'string') {
      backgroundImage = theme.backgroundImageContent;
    } else {
      const keys = Object.keys(theme.backgroundImageContent);
      if (keys.length > 0) {
        backgroundImage = theme.backgroundImageContent[keys[0]];
      }
    }
  }
  
  if (backgroundImage) {
    slideBackgroundCache[cacheKey] = backgroundImage;
  }
  
  return backgroundImage || '';
} 